<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
    <div class="vx-row">
      <div class="w-full">
        <div
          slot="no-body"
          class="tabs-container inventory_tabSec pt-6"
          id="view-customer-tab"
        >
          <div>
            <vx-card>
              <vs-table
                :max-items="paginationItems[1]"
                pagination
                :data="paymentGatewayConfigsData"
                :description="false"
                search
                :description-items="paginationItems"
                description-title="Registries"
                description-connector="of"
                description-body="Pages"
              >
                <template slot="header">
                  <div class="list-heading1">
                    {{ $t("system.label.PaymentGatewayConfiguration") }}
                  </div>
                  <div class="mr-2 mb-1 order-1"></div>
                </template>
                <template slot="thead">
                  <th>{{ $t("system.label.Name") }}</th>
                  <th>{{ $t("system.label.Enabled") }}</th>
                  <th>{{ $t("system.label.Value") }}</th>
                  <th>{{ $t("system.label.Action") }}</th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :key="index"
                    :data="paymentGatewayConfigsData"
                    v-for="(paymentGatewayConfigsData, index) in data"
                  >
                    <vs-td :data="paymentGatewayConfigsData.name">{{
                      paymentGatewayConfigsData.name
                    }}</vs-td>
                    <vs-td :data="paymentGatewayConfigsData.enabled">{{
                      paymentGatewayConfigsData.enabled
                    }}</vs-td>

                    <vs-td
                      :data="paymentGatewayConfigsData.value"
                      class="width20"
                      >{{ paymentGatewayConfigsData.value }}</vs-td
                    >

                    <vs-td class="whitespace-no-wrap">
                      <vs-td :data="paymentGatewayConfigsData.enabled"
                        ><vs-switch
                          v-model="paymentGatewayConfigsData.enabled"
                          @change="
                            updatePaymentGatewayFlag(
                              paymentGatewayConfigsData.id,
                              paymentGatewayConfigsData.enabled
                            )
                          "
                      /></vs-td>
                      <feather-icon
                        v-if="paymentGatewayConfigsData.value"
                        icon="EditIcon"
                        :title="$t('system.label.Edit')"
                        svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                        @click.stop="
                          editPaymentGatwayConfig(paymentGatewayConfigsData)
                        "
                        class="icon_row"
                      />
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vx-card>
          </div>
        </div>

        <!-- edit paymentgatway configuration -->
        <div class="centerx">
          <vs-popup
            class="popup-close"
            :title="$t('system.label.EditPaymentGatewayConfiguration')"
            :active.sync="editPaymentGatwayConfigPopup"
          >
            <div class="">
              <div class="w-full">
                <vs-table
                  :data="keyValues"
                  :description="false"
                  description-title="Registries"
                  description-connector="of"
                  description-body="Pages"
                >
                  <template slot="thead">
                    <th>{{ $t("system.label.Key") }}</th>
                    <th>{{ $t("system.label.Value") }}</th>
                    <th class="tHeadCenter">{{ $t("system.label.Action") }}</th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr
                      :key="index"
                      :data="keyValues"
                      v-for="(valuesPairKeys, index) in data"
                    >
                      <vs-td>
                        <vs-input
                          :label="$t('system.label.EnterKeyHere')"
                          class="w-full font-semibold mb-2"
                          v-model="valuesPairKeys.key"
                          :id="index"
                          :disabled="valuesPairKeys.disable"
                        />
                      </vs-td>
                      <vs-td>
                        <vs-input
                          :id="index"
                          :label="$t('system.label.EnterValueHere')"
                          v-model="valuesPairKeys.value"
                          class="w-full font-semibold mb-2"
                          :disabled="valuesPairKeys.disable"
                        />
                      </vs-td>

                      <vs-td class="whitespace-no-wrap">
                        <div class="container_img">
                          <feather-icon
                            icon="EditIcon"
                            :title="$t('system.label.Edit')"
                            svgClasses="w-5 h-5  stroke-current cursor orange_icon"
                            @click="editConfigParams(index)"
                            class="icon_row"
                          />
                          <button
                            class="bGNone border-none view_editTable_btn"
                            @click="deleteConfigParams(index)"
                          >
                            <feather-icon
                              icon="TrashIcon"
                              :title="$t('system.label.Delete')"
                              svgClasses="w-5 h-5 text-danger stroke-current cursor"
                              class="icon_row"
                            />
                          </button>
                          <feather-icon
                            icon="PlusIcon"
                            :title="$t('system.label.Add')"
                            class="text-warning icon_row"
                            v-if="keyValues.length - index == 1"
                            svgClasses="w-5 h-5 stroke-current cursor"
                            @click="createConfigParams()"
                          />
                        </div>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
            <div class="button-container mt-3">
              <span class="ml-4 mr-2">
                <vs-button
                  type="border"
                  @click="editPaymentGatwayConfigPopup = false"
                  >{{ $t("system.label.cancel") }}</vs-button
                >
              </span>
              <span class="ml-1">
                <vs-button @click="editPaymentConfig">{{
                  $t("system.label.Submit")
                }}</vs-button>
              </span>
            </div>
          </vs-popup>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapGetters } from "vuex";
import { mapState } from "vuex";
import vSelect from "vue-select";

export default {
  data() {
    return {
      loading: false,
      paginationItems: [5, 10, 15],
      editGlobalConfigurationValue: false,
      editValueConfig: "",
      editPaymentGatwayConfigPopup: false,
      createConfigurationPopup: false,
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      valuesPair: {},
      valuesPairKeys: "",
      showKey: "",
      showValue: "",
      keyValues: [],
      enabledOptions: [true, false],
      idEditPaymentConfig: "",
      activeTab: 0,
      name: "",
      enabled: "",
      value: "",
      module: "",
      description: "",
    };
  },
  components: {
    AtomSpinner,
    "v-select": vSelect,
  },
  computed: {
    ...mapGetters({
      configurationsData: "configuration/getConfigurationsList",
      paymentGatewayConfigsData: "configuration/getPaymentGatewayConfigsList",
      eventactionMappingData: "configuration/getEventactionMappingList",
      ByIdConfigurationsData: "configuration/getByIdConfigurationsDataList",
    }),
    ...mapState({
      enumConfig: (state) => state.configuration.enumConfig,
    }),
  },
  methods: {
    async getPaymentGatewayConfigsList() {
      this.loading = true;
      try {
        await this.$store.dispatch(
          "configuration/setPaymentGatewayConfigsList"
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },

    async editPaymentGatwayConfig(value) {
      this.keyValues = [];
      this.valuesPair = JSON.parse(value.value);
      this.idEditPaymentConfig = value.id;
      for (let key in this.valuesPair) {
        let value = this.valuesPair[key];
        this.showKey = key;
        this.showValue = value;
        this.keyValues.push({ key: key, value: value, disable: true });
      }
      this.editPaymentGatwayConfigPopup = true;
    },
    createConfigParams() {
      this.keyValues.push({ key: "", value: "", disable: false });
    },
    editConfigParams(index) {
      this.keyValues[index].disable = false;
    },
    deleteConfigParams: function (index) {
      this.keyValues.splice(index, 1);
    },
    async editPaymentConfig() {
      let editPaymentValueKey = {};
      this.keyValues.forEach((el) => {
        editPaymentValueKey[el.key] = el.value;
        delete el.disable;
      });
      let payload = {
        value: JSON.stringify(editPaymentValueKey),
        id: this.idEditPaymentConfig,
      };
      try {
        await this.$store.dispatch(
          "configuration/setEditByIdPaymentConfig",
          payload
        );

        this.getPaymentGatewayConfigsList();
        this.editPaymentGatwayConfigPopup = false;
        // this.$router.push("/system_config");
      } catch (e) {
        this.errorMessage = e.message;
      }
    },
    async updateFlag(id, isEnabled) {
      const payload = { enabled: isEnabled ? "true" : "false" };
      try {
        await this.$store.dispatch(
          "configuration/updateConfigurationFlagAction",
          { id, data: payload }
        );
      } catch (e) {
        this.errorMessage = e.message;
      }
    },
    async updatePaymentGatewayFlag(id, isEnabled) {
      const payload = { enabled: isEnabled ? "true" : "false" };
      try {
        await this.$store.dispatch(
          "configuration/updatePaymentgatewayConfigurationFlagAction",
          { id, data: payload }
        );
      } catch (e) {
        this.errorMessage = e.message;
      }
    },
  },
  mounted() {
    this.getPaymentGatewayConfigsList();
  },
};
</script>
<style scoped>
.product-order-status.vs-chip-success {
  background: #d5ebdb !important;
  border: 1px solid #34a853;
  color: #34a853 !important;
}
.product-order-status.vs-chip-orange {
  background: #fffae7 !important;
  border: 1px solid #ffcb14;
  color: #ffcb14 !important;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
.view_editTable_btn {
  background: transparent;
  cursor: pointer;
}
.width15 {
  max-width: 15%;
  word-break: break-all;
}
.width20 {
  max-width: 20%;
  word-break: break-all;
}
.button-container {
  display: flex;
  justify-content: flex-end;
}
.list-heading1 {
  font-size: 22px;
  font-weight: 500;
}
</style>
